// Componente principal da página de recuperação de senha
import * as React from 'react';
import ForgotPasswordContainer from './ForgotPasswordContainer';

const ForgotPassword: React.FC = () => {
  return <ForgotPasswordContainer />;
};

export default ForgotPassword;